"use client";

import { ArrowRight, Newspaper } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OrganizationalHero() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1016" id="organizationalhero" className="relative overflow-hidden bg-background pt-32 md:pt-44 pb-32 md:pb-44">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-20 -left-16 h-72 w-72 md:h-96 md:w-96" style={{
      background: "hsl(25 83% 55% / 0.1)",
      borderRadius: "62% 38% 47% 53% / 45% 60% 40% 55%"
    }} />
      <div aria-hidden="true" className="pointer-events-none absolute top-1/3 right-1/4 h-60 w-60 hidden md:block" style={{
      background: "hsl(27 31% 22% / 0.08)",
      borderRadius: "58% 42% 63% 37% / 50% 45% 55% 50%"
    }} />

      <div className="container mx-auto max-w-[1320px] px-6 md:px-8 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div ref={contentRef} className="lg:col-span-7 transition-all duration-700 ease-out" style={{
          transform: contentVisible ? "translateY(0)" : "translateY(24px)",
          opacity: contentVisible ? 1 : 0
        }}>
            {}
            <div className="flex items-center gap-3 mb-8">
              {}
              <span aria-hidden="true" className="relative inline-flex">
                <span className="block h-1.5 w-1.5 rounded-lg" style={{
                background: "hsl(25 83% 55%)"
              }} />
                <svg className="absolute -top-1 -right-1" width="8" height="8" viewBox="0 0 8 8" fill="none">
                  <path d="M1 7 Q 4 4 7 1" stroke="hsl(27 31% 22%)" strokeWidth="1.2" strokeLinecap="round" fill="none" />
                </svg>
              </span>
              <span className="font-default text-xs md:text-sm font-medium uppercase text-foreground" style={{
              letterSpacing: "0.16em"
            }}>
                01 — Portal Berita Nasional
              </span>
            </div>

            {}
            <h1 className="font-default font-bold text-foreground" style={{
            fontSize: "clamp(3.25rem, 7vw, 6.5rem)",
            letterSpacing: "-0.025em",
            lineHeight: "0.95"
          }}>
              Informasi Terkini{" "}
              <span className="relative inline-block italic">
                <span className="relative z-10">ABADI.NEWS</span>
                <svg aria-hidden="true" className="absolute left-0 right-0 -bottom-2 w-full h-[0.55em] pointer-events-none" viewBox="0 0 200 40" preserveAspectRatio="none" fill="none" style={{
                zIndex: 0
              }}>
                  <path d="M4 28 Q 30 8, 60 22 T 120 20 T 196 18" stroke="hsl(25 83% 55%)" strokeWidth="14" strokeLinecap="round" fill="none" style={{
                  strokeDasharray: 400,
                  strokeDashoffset: contentVisible ? 0 : 400,
                  transition: "stroke-dashoffset 900ms ease-out 200ms"
                }} />
                </svg>
              </span>
            </h1>

            {}
            <p className="mt-8 font-default font-normal max-w-[52ch]" style={{
            color: "hsl(27 31% 22%)",
            fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
            lineHeight: "1.55"
          }}>
              Portal berita nasional terpercaya yang menyajikan informasi akurat, 
              berimbang, dan mendalam untuk masyarakat Indonesia. Kami hadir 
              sebagai referensi utama berita terkini setiap saat.
            </p>

            {}
            <div className="mt-10 flex flex-col sm:flex-row gap-4 sm:gap-5">
              <Button asChild className="group rounded-lg h-auto px-7 py-3.5 text-base font-bold font-default bg-primary text-primary-foreground border-[1.5px] hover:bg-primary/90 transition-all duration-200 hover:translate-x-0.5" style={{
              borderColor: "hsl(27 31% 22%)",
              boxShadow: "0 0 0 hsl(27 31% 22%)"
            }} onMouseEnter={e => {
              (e.currentTarget as HTMLElement).style.boxShadow = "4px 4px 0 hsl(27 31% 22%)";
            }} onMouseLeave={e => {
              (e.currentTarget as HTMLElement).style.boxShadow = "0 0 0 hsl(27 31% 22%)";
            }}>
                <Link to="/NewsPage">
                  Baca Berita Terkini
                  <ArrowRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild variant="outline" className="rounded-lg h-auto px-7 py-3.5 text-base font-bold font-default bg-transparent border-[1.5px] text-foreground hover:bg-foreground hover:text-background transition-colors duration-200" style={{
              borderColor: "hsl(27 31% 22%)"
            }}>
                <Link to="/SendNewsPage">
                  <Newspaper className="mr-1 h-4 w-4" />
                  Kirim Berita Anda
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className="lg:col-span-5 relative transition-all duration-700 ease-out" style={{
          transform: imageVisible ? "translateY(0)" : "translateY(24px)",
          opacity: imageVisible ? 1 : 0,
          transitionDelay: "150ms"
        }}>
            <div className="relative mx-auto max-w-[480px] lg:max-w-none">
              {}
              <div aria-hidden="true" className="pointer-events-none absolute -top-8 -left-8 h-32 w-32 md:h-40 md:w-40" style={{
              background: "hsl(25 83% 55% / 0.2)",
              borderRadius: "58% 42% 63% 37% / 50% 45% 55% 50%"
            }} />
              <div aria-hidden="true" className="pointer-events-none absolute -bottom-10 -right-6 h-36 w-36 md:h-44 md:w-44" style={{
              background: "hsl(27 31% 22% / 0.15)",
              borderRadius: "62% 38% 47% 53% / 45% 60% 40% 55%"
            }} />

              {}
              <div className="relative overflow-hidden border-[1.5px]" style={{
              borderRadius: "62% 38% 47% 53% / 45% 60% 40% 55%",
              borderColor: "hsl(27 31% 22%)",
              aspectRatio: "1 / 1.05"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/national_news_hero.png" alt="Jurnalis meliput berita nasional dengan latar belakang gedung pemerintahan" className="absolute inset-0 h-full w-full object-cover" loading="lazy" decoding="async" />
              </div>

              {}
              <div className="absolute top-2 right-2 md:-top-2 md:-right-4 z-10" style={{
              transform: "rotate(-6deg)"
            }}>
                <div className="bg-card px-4 py-2.5 border-[1.5px] border-dashed shadow-md" style={{
                borderColor: "hsl(27 31% 22%)",
                borderRadius: "1rem"
              }}>
                  <div className="flex items-center gap-2">
                    <span aria-hidden="true" className="block h-2 w-2 rounded-lg" style={{
                    background: "hsl(25 83% 55%)"
                  }} />
                    <span className="font-default text-xs font-medium uppercase text-foreground" style={{
                    letterSpacing: "0.12em"
                  }}>
                      Update 24/7
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <div aria-hidden="true" className="absolute bottom-0 left-0 right-0 leading-[0]">
        <svg className="block w-full h-8 md:h-16" viewBox="0 0 1440 64" preserveAspectRatio="none" fill="none">
          <path d="M0 32 Q 180 0, 360 32 T 720 32 T 1080 32 T 1440 32 L 1440 64 L 0 64 Z" fill="hsl(27 31% 22%)" />
        </svg>
      </div>
    </section>;
}